import { createContext } from 'react';
import EditFDConfigContext from 'types/contexts/EditFDConfigContext';

export default createContext({} as EditFDConfigContext);
